// Jonny Sprockets Bike Shop — Have Fun if you copy :)
  // Custom cart location badge. All rights reserved.
(() => {
  const STOREFRONT_TOKEN = '72366196775790fbd2d3aceda3716b16';
  const STOREFRONT_URL = 'https://jonnysprockets.au/api/2025-10/graphql.json';

  const STORE_LOCATION_ID = 'gid://shopify/Location/66293170392';
  const WAREHOUSE_IDS = [
    'gid://shopify/Location/72008958168',
    'gid://shopify/Location/78207025368'
  ];

  const buildQuery = (variantIds) => `{
    nodes(ids: [${variantIds.map(id => `"gid://shopify/ProductVariant/${id}"`).join(',')}]) {
      ... on ProductVariant {
        id
        storeAvailability(first: 10) {
          edges {
            node {
              quantityAvailable
              location { id name }
            }
          }
        }
      }
    }
  }`;

  const fetchLocationInventory = async (variantIds) => {
    const res = await fetch(STOREFRONT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query: buildQuery(variantIds) })
    });
    const { data } = await res.json();
    return data?.nodes || [];
  };

  const getPriority = (storeQty, warehouseQty, cartQty) => {
    if (storeQty >= cartQty) return { type: 'store' };
    if (storeQty > 0 && warehouseQty > 0) return { type: 'partial', storeQty };
    if (warehouseQty > 0) return { type: 'warehouse' };
    if (storeQty > 0) return { type: 'store' };
    return { type: 'soldout' };
  };

  const renderBadge = (el, priority) => {
    const dot = '<span class="cart-item-location__dot"></span>';
    switch (priority.type) {
      case 'store':
        el.className = 'cart-item-location cart-item-location--store';
        el.innerHTML = `${dot}In store`;
        break;
      case 'partial':
        el.className = 'cart-item-location cart-item-location--partial';
        el.innerHTML = `${dot}${priority.storeQty} in store · rest order in`;
        break;
      case 'warehouse':
        el.className = 'cart-item-location cart-item-location--warehouse';
        el.innerHTML = `${dot}Order in · 3–7 days`;
        break;
      case 'soldout':
        el.className = 'cart-item-location cart-item-location--soldout';
        el.innerHTML = `${dot}Sold out`;
        break;
    }
  };

  const updateBadges = async () => {
    const badges = Array.from(document.querySelectorAll('cart-drawer .cart-item-location[data-variant-id]'));
    if (!badges.length) return;

    const variantIds = [...new Set(badges.map(b => b.dataset.variantId))];

    let nodes;
    try {
      nodes = await fetchLocationInventory(variantIds);
    } catch (e) {
      console.error('Cart location fetch failed:', e);
      return;
    }

    // Build inventory map
    const inventoryMap = {};
    nodes.forEach(node => {
      if (!node?.id) return;
      const variantId = node.id.replace('gid://shopify/ProductVariant/', '');
      let storeQty = 0;
      let warehouseQty = 0;

      node.storeAvailability.edges.forEach(({ node: avail }) => {
        const locId = avail.location.id;
        if (locId === STORE_LOCATION_ID) {
          storeQty = avail.quantityAvailable;
        } else if (WAREHOUSE_IDS.includes(locId)) {
          warehouseQty += avail.quantityAvailable;
        }
      });

      inventoryMap[variantId] = { storeQty, warehouseQty };
    });

    // Update each badge
    badges.forEach(badge => {
      const variantId = badge.dataset.variantId;
      const cartQty = parseInt(badge.dataset.cartQty || '1', 10);
      const inv = inventoryMap[variantId];
      if (!inv) return;

      const priority = getPriority(inv.storeQty, inv.warehouseQty, cartQty);
      renderBadge(badge, priority);
    });
  };

  // Hook into cart drawer open and cart updates
  document.addEventListener('cart:open', updateBadges);
  document.addEventListener('cart:refresh', updateBadges);

  // Intercept cart fetch calls to trigger badge update after quantity changes
  const origFetch = window.fetch;
  window.fetch = function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const result = origFetch.apply(this, args);
    if (url.includes('/cart.js') || url.includes('/cart.json')) {
      result.then(() => {
        const cartItems = document.querySelector('#CartDrawer-CartItems');
        if (!cartItems) return setTimeout(updateBadges, 100);

        const obs = new MutationObserver(() => {
          obs.disconnect();
          updateBadges();
        });
        obs.observe(cartItems, { childList: true, subtree: true });
        setTimeout(() => { obs.disconnect(); updateBadges(); }, 800);
      });
    }
    return result;
  };

// Watch for cart drawer opening via attribute/class change on the cart-drawer element
  document.addEventListener('DOMContentLoaded', () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    new MutationObserver(() => {
      if (cartDrawer.classList.contains('is-visible')) {
        updateBadges();
      }
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  });

})();